import { editDialogConfig } from "../constants/textConfig";
import Act from "../../../../../store/actions";

export const prepareEditDialog = (
  dispatch,
  type,
  {
    curMainEvn = "",
    curSubEvn = "",
    curRowId = "",
    newTableData = [],
    evtTypeId = "",
  } = {}
) => {
  if (!dispatch || !type) return;

  let payload = {
    open: true,
    type,
    title: editDialogConfig[type]?.title || "",
    content: editDialogConfig[type]?.content || "",
    deletedTableData: [],
    curMainEvn,
    curSubEvn,
    curRowId,
    evtTypeId,
  };

  switch (type) {
    case editDialogConfig.deleteRow.name:
      payload = {
        ...payload,
        deletedTableData: newTableData,
      };
      break;
    case "closeDialog":
      payload = {
        open: false,
        type: "",
        title: "",
        content: "",
        deletedTableData: [],
        curMainEvn: "",
        curSubEvn: "",
        curRowId: "",
        evtTypeId: "",
      };
      break;
    default:
      break;
  }

  dispatch({
    type: Act.SNA_SET_EDIT_DIALOG,
    payload,
  });
};
